export const externalServices = {
  swissEnergyLabelPdfUrl: 'https://www.bfe-anw.admin.ch/ee/etikette_output.php',
};
